module.exports = __webpack_public_path__ + "static/app-store_badge--white-1d1faf8f4a95d6394703b3432e4352fb.svg";